import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import { createApp } from 'vue';
import './style.css';
import App from './App.vue';
import router from './router';

// Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import VueDraggableResizable from 'vue-draggable-resizable';
import * as Sentry from '@sentry/vue';

const vuetify = createVuetify({
  icons: {
    defaultSet: 'mdi',
  },
  defaults: {
    VApp: {
      style: 'font-family: "Montserrat", sans-serif;',
    },
  },
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#5d6ae3',
          cardColor: '#FFFFFF',
          cardColorAlt: '#ececec',
          cardColorAltAlt: '#f5f5f5',
          text: '#2d2d2d',
          wideCardHover: '#7680e0',
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: '#5d6ae3',
          cardColor: '#1f1f23',
          cardColorAlt: '#4b4b4f',
          cardColorAltAlt: '#171717',
          text: '#ffffff',
          wideCardHover: '#7680e0',
        },
      },
    },
  },
  components,
  directives,
});

const isSentryEnabled =
  !import.meta.env.DEV && localStorage.getItem('userConsent') === 'true';

let app = createApp(App);

Sentry.init({
  app,
  dsn: 'https://fbb4653b9fb1d48962a211ab97b26363@o4509122860941312.ingest.de.sentry.io/4509327155986512',
  release: import.meta.env.VITE_SENTRY_RELEASE,
  sendDefaultPii: false,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.1,
  profilesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enabled: isSentryEnabled,
  environment: import.meta.env.MODE,
  beforeSend(event) {
    const { state } = require('@/stores/deluge.js'); // Import state only when needed
    if (!state.current_user?.extra_info?.user_consent) {
      return null;
    }
    return event;
  },
  beforeSendTransaction(event) {
    const { state } = require('@/stores/deluge.js'); // Import state only when needed
    if (!state.current_user?.extra_info?.user_consent) {
      return null;
    }
    return event;
  },
  beforeBreadcrumb(breadcrumb, hint) {
    const { state } = require('@/stores/deluge.js'); // Import state only when needed
    if (!state.current_user?.extra_info?.user_consent) {
      return null;
    }
    return breadcrumb;
  },
});

app
  .component('vue-draggable-resizable', VueDraggableResizable)
  .use(vuetify)
  .use(router)
  .mount('#app');
